import { Label } from 'components/atoms';
import { Contract, FormInput } from 'components/molecules';
import { useFormikContractHelpers } from 'hooks';
import i18next from 'i18next';
import {
  ITemplatesLightListItem,
  TEMPLATE_TYPE,
} from 'services/templates/types';
import './ContractSideMenuTemplateListWrapper.scss';

interface IContractSideMenuTemplateListWrapperProps {
  templates?: ITemplatesLightListItem[];
  templateType: TEMPLATE_TYPE;
  headerTitle?: string;
  item: (
    value: ITemplatesLightListItem,
    index: number,
    array: ITemplatesLightListItem[]
  ) => JSX.Element;
}

const ContractSideMenuTemplateListWrapper = ({
  templates,
  templateType,
  headerTitle: headerTitleProp,
  item,
}: IContractSideMenuTemplateListWrapperProps) => {
  const { values } = useFormikContractHelpers();

  const getFilteredTemplates = () =>
    templates?.filter(({ title }) =>
      title && values.sideMenu?.customTemplate
        ? `${title}`
            .toLowerCase()
            .trim()
            .includes(
              values.sideMenu.customTemplate.search.toLowerCase().trim()
            )
        : true
    ) ?? [];

  const headerTitle =
    headerTitleProp ??
    (templateType === TEMPLATE_TYPE.section
      ? i18next.t('contract-template.section.custom')
      : templateType === TEMPLATE_TYPE.paragraphSection
        ? i18next.t('contract-template.paragraphSection.custom')
        : i18next.t(`enum.TEMPLATE_TYPE.${TEMPLATE_TYPE[templateType]}`));

  return (
    <Contract.SideMenu.Wrapper
      header={
        <>
          <Label withText title={headerTitle}>
            {headerTitle}
          </Label>
          <span className='w-[44px]' />
        </>
      }>
      <div className='contract-side-menu-templates-content-wrapper'>
        <FormInput.Text
          name='sideMenu.customTemplate.search'
          label='Search'
          placeholder={headerTitle}
        />
        <div className='contract-side-menu-templates-list'>
          {getFilteredTemplates().map(item)}
        </div>
      </div>
    </Contract.SideMenu.Wrapper>
  );
};

export default ContractSideMenuTemplateListWrapper;
